import React from 'react';

import { CardsContainer } from '../../../../../components/v2/Card';
import HeroImageSetting from './HeroImageSetting';
import ColorModeSetting from './ColorModeSetting';

const CheckoutPageConfiguration = () => (
  <CardsContainer>
    <HeroImageSetting />
    <ColorModeSetting />
  </CardsContainer>
);

export default CheckoutPageConfiguration;
